import { ReactNode } from 'react';

type ProductHeadingProps = {
  children: ReactNode;
  className?: string;
};

export const ProductHeading = ({
  children,
  className,
}: ProductHeadingProps) => (
  <h1 className={className}>{children}</h1>
);
